import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import colors from "../Constant/colors";
import { hasPermission } from "../utils/permissionUtils";

const TeacherManagement = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const cardStyle = {
    background: "#ffffff",
    borderRadius: "14px",
    boxShadow: `0 4px 12px ${colors.cardShadow}`,
    padding: "18px 20px",
    display: "flex",
    alignItems: "center",
    gap: "18px",
    cursor: "pointer",
    transition: "0.2s",
    minHeight: "120px",
    height: "100%",
  };

  const heading = {
    fontSize: "18px",
    fontWeight: "600",
    color: colors.grayDark,
  };

  const subheading = {
    fontSize: "12px",
    opacity: 0.7,
    marginTop: "2px",
  };

  const iconStyle = {
    fontSize: "32px",
    minWidth: "40px",
  };

  return (
    <div
      style={{ background: "#ffffff", minHeight: "100vh" }}
      className="flex justify-center items-start p-6"
    >
      <div className="w-full max-w-7xl">

        <div
          className={`grid gap-6 ${
            isMobile ? "grid-cols-1" : "grid-cols-3"
          }`}
          style={{ alignItems: "stretch" }}
        >

          {/* 🔹 STAFF ENROLLMENT */}
          {hasPermission("staff_enrollment") && (
            <Link to="/teacher-enrollment" className="flex">
              <div style={cardStyle} className="hover:scale-[1.01] w-full">
                <i
                  className="fas fa-user-plus"
                  style={{ ...iconStyle, color: "#FF8C42" }}
                />
                <div>
                  <h2 style={heading}>Staff Enrollment</h2>
                  <p style={subheading}>
                    Add teaching or non-teaching staff.
                  </p>
                </div>
              </div>
            </Link>
          )}

          {/* 🔹 STAFF ATTENDANCE */}
          {hasPermission("staff_attendance") && (
            <Link to="/staff-attendance" className="flex">
              <div style={cardStyle} className="hover:scale-[1.01] w-full">
                <i
                  className="fas fa-calendar-check"
                  style={{ ...iconStyle, color: "#1E90FF" }}
                />
                <div>
                  <h2 style={heading}>Staff Attendance</h2>
                  <p style={subheading}>
                    Track and manage attendance.
                  </p>
                </div>
              </div>
            </Link>
          )}

          {/* 🔹 ADD DESIGNATION */}
          {hasPermission("add_designation") && (
            <Link to="/add-designation" className="flex">
              <div style={cardStyle} className="hover:scale-[1.01] w-full">
                <i
                  className="fas fa-cogs"
                  style={{ ...iconStyle, color: "#8A2BE2" }}
                />
                <div>
                  <h2 style={heading}>Add Designation</h2>
                  <p style={subheading}>
                    Create roles & staff categories.
                  </p>
                </div>
              </div>
            </Link>
          )}

          {/* 🔹 BULK UPLOAD TEACHERS */}
          {hasPermission("bulk_upload_teacher") && (
            <Link to="/bulk-teacher-upload" className="flex">
              <div style={cardStyle} className="hover:scale-[1.01] w-full">
                <i
                  className="fas fa-file-excel"
                  style={{ ...iconStyle, color: "#2E7D32" }}
                />
                <div>
                  <h2 style={heading}>Bulk Upload Teachers</h2>
                  <p style={subheading}>
                    Upload multiple teachers from Excel or CSV.
                  </p>
                </div>
              </div>
            </Link>
          )}

        </div>
      </div>
    </div>
  );
};

export default TeacherManagement;
